module.exports = __webpack_public_path__ + "app/assets/images/man21-8d18b1ec9572a7480541299460645e0f.jpg";